export const CMS_CONTENT_IDS = {
  NEW_MAP_BANNER: 'c81da057-8279-4e05-b966-4fd8cc16842d',
  NEW_MAP_MODAL: '24812d41-5275-4265-9228-cb0f349cb65e',
  // 프라이싱 페이지 FAQ (CMS 제목: 퀴즈_프라이싱_FAQ). 위글루 oEFlK… 에서 이관.
  PRICING_FAQ: '4c01fdb6-3af5-48b9-abb8-4c006b4bc697',
} as const;
